/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { baseRequest } from './baseRequest';
import { encryptFile } from '../utils/encryption';
const baseRoute = '/api/internal/keys';
export const uploadKey = async file => {
  const response = await baseRequest.get(`${baseRoute}/jwks`);
  const rsaKey = response.data.keys[0];
  const {
    aesIv,
    aesKey,
    userKey
  } = await encryptFile(file, rsaKey);
  return baseRequest.post(`${baseRoute}/`, {
    aesIv,
    aesKey,
    userKey
  });
};